module.exports = __webpack_public_path__ + "static/media/google_16.d15f966b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/google_16.svg
// module id = 868
// module chunks = 0